/* eslint-disable no-unused-vars */
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

export const dashboardAPI = createApi({
  reducerPath: 'DashboardAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api' }),
  tagTypes: [],
  endpoints: (build) => ({
    GetCampaignStatusCounters: build.query({
      query: (data) => ({
        url: '/Campaign/GetCampaignStatusCounters',
        method: 'POST',
        data,
      }),
    }),
    GetPublisherAppStatusCounters: build.query({
      query: (data) => ({
        url: '/AppsManage/GetPublisherAppStatusCounters',
        method: 'POST',
        data,
      }),
    }),
    GetAdvertiserPerformanceCards: build.query({
      query: (data) => ({
        url: '/Campaign/GetAdvertiserPerformanceCards',
        method: 'POST',
        data,
      }),
    }),
    GetApplicationsBlock: build.query({
      query: (data) => ({
        url: '/Campaign/GetApplicationsBlock',
        method: 'POST',
        data,
      }),
    }),
    GetCampaignsBlock: build.query({
      query: (data) => ({
        url: '/Campaign/GetCampaignsBlock',
        method: 'POST',
        data,
      }),
    }),
    GetTopEventsBlock: build.query({
      query: (data) => ({
        url: '/Campaign/GetTopEventsBlock',
        method: 'POST',
        data,
      }),
    }),
    GetPublisherPerformanceCards: build.query({
      query: (data) => ({
        url: '/Revenue/GetPublisherPerformanceCards',
        method: 'POST',
        data,
      }),
    }),
    GetPublisherApplicationsBlock: build.query({
      query: (data) => ({
        url: '/Revenue/GetApplicationsBlock',
        method: 'POST',
        data,
      }),
    }),
  }),
});
